import { BaseApiService } from '@/shared/api/services/base.service';
import type { Material, MaterialsResponse } from '@/types/material';

class MaterialsService extends BaseApiService {
  async getMaterials(): Promise<Material[]> {
    const response = await this.httpGet<MaterialsResponse>('/v1/materials');
    return response.data;
  }
}

export const materialsService = new MaterialsService();
